<template>
  <div>
    <!-- <div>
      <i
        class="icon icon-bar-chart cur-pointer"
        v-show="chartType == 'bar'"
        @click="changeChartType()"
      ></i>
      <i
        class="icon icon-pie-chart cur-pointer"
        v-show="chartType == 'pie'"
        @click="changeChartType()"
      ></i>
    </div> -->
    <el-dialog title="" :visible.sync="open" width="50%">
      <div class="chart-container">
        <div id="chart_box" ></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TableCharts",
  data() {
    return {
      open: false,
      myChart: null,
    };
  },
  props: {
    chartType: {
      type: String,
      default: "bar",
    },
    chartData: {
      type: Array,
      default: ()=>[],
    },
  },
  watch: {
    chartData() {
      this.changeChartType();
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.changeChartType();
    // });
  },
  methods: {
    changeChartType() {
      // 按年份从小到大排序
     
      if (this.chartType == "bar") {
        this.drawBarChart();
      } else if (this.chartType == "pie") {
        this.drawPieChart();
      }else if (this.chartType == "line"){
        this.drawLineChart();
      }
    },
    
    drawBarChart() {
      this.$nextTick(() => {
      this.myChart = echarts.init(document.getElementById("chart_box"));
      this.myChart.clear();
			var _this = this;
      let xAxisData = [];
      let yAxisData = [];
      for (let i = 0; i < this.chartData.length; i++) {
        console.log(this.chartData[i]);
        xAxisData.push(this.chartData[i].label);
        yAxisData.push(this.chartData[i].value);
      }
			let option = {
				tooltip: {
					trigger: 'item',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					},
					formatter: function (params) {
						let rethtml = params.marker + params.name + "年"  + "：" + params.value;
						return rethtml;
					}
				},
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true },
          },
        },
				xAxis: {
					type: 'category',
					data: xAxisData,
				},
				yAxis: {
					type: 'value',
				},
				series: [{
					data: _this.chartData,
					type: 'bar',
					barWidth: 24,
				}]
			};
			this.myChart.setOption(option);
      })
			
		},
    drawPieChart() {
      this.$nextTick(() => {
      this.myChart = echarts.init(document.getElementById("chart_box"));
      this.myChart.clear();
      const options = {
        title: {},
        tooltip: {
          trigger: "item",
        },
        // legend: {
        //  orient: 'vertical',
        // left: 'left'
        // },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true },
          },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            data: this.chartData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}年: {c} ({d}%)",
            },
          },
        ],
      };

      this.myChart.setOption(options);
      });
    },
    drawLineChart() {
      this.$nextTick(() => {
      this.myChart = echarts.init(document.getElementById("chart_box"));
      this.myChart.clear();
      let xAxisData = [];
      let yAxisData = [];
      for (let i = 0; i < this.chartData.length; i++) {
        xAxisData.push(this.chartData[i].label);
        yAxisData.push(this.chartData[i].value);
      }
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: "{b}年: {c}%",
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true },
          },
        },
        xAxis: {
          type: "category",
          data: xAxisData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: yAxisData,
            type: "line",
          },
        ]
  }
      this.myChart.setOption(option);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#chart_box {
  width: 900px;
  height: 400px;
}
</style>